module.exports = __webpack_public_path__ + "img/golem-foundation.2feb2ca3.png";